// pages/brand/CreateBrand.js
import React from 'react';
import { Link } from 'react-router-dom';
import BrandForm from '../../components/brand/BrandForm';
import { ChevronLeft } from 'lucide-react';

function CreateBrandPage() {
  return (
    <div>
      <div className="px-4 max-w-4xl mx-auto mt-4">
        <Link 
          to="/mybrands" 
          className="inline-flex items-center text-blue-600 hover:text-blue-800"
        >
          <ChevronLeft size={16} className="mr-1" />
          Back to My Brands
        </Link>
      </div>
      
      <BrandForm />
    </div>
  );
}

export default CreateBrandPage;